<template>
<div>
    <bar-manut 
        single-entity="Ramo de Atividade"
        plural-entity="Ramos de Atividade"
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field v-model="ramoat.codramo" :metadata="metadata.ramoat.codramo" type="text" col="2" :disabled="true"></form-field>
                <form-field v-model="ramoat.descricao" type="text" col="4" :metadata="metadata.ramoat.descricao" 
                    name="descricao" :v-errors="errors" v-validate="metadata.ramoat.descricao.validator"></form-field>
            </div>
            <div class="row">
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            ramoat: {...this.$store.getters.getEntities.ramoat},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }
    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.ramoat.codramo)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadRamoat', { id: this.index } )
            if (this.$store.getters.getRamoat) {
                this.ramoat = {...this.$store.getters.getRamoat}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/ramoat/' + this.ramoat.codramo

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/ramoat/'
            var sendData = {}

            sendData = { ramoat: this.ramoat }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/ramoat-form.vue